import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getFaqArticleRequest = async (id: number) => {
  const response: AxiosResponse = await apiInstance.get(`/faq/${id}`);

  return response.data;
};
